import { loadable } from 'utils';

export const Partner = loadable(() => import('./Partner'), {});
